import MField from "./MField.vue";
export default MField;
export type { MFieldProps } from "./MField.props";
